var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "card search-card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("面談日期"),
                              ]),
                              _c("ValidationProvider", {
                                attrs: { rules: { dateRangeRequired: true } },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("el-date-picker", {
                                            staticClass: "w-100",
                                            attrs: {
                                              type: "daterange",
                                              clearable: false,
                                              "picker-options": {
                                                disabledDate:
                                                  _vm.$common
                                                    .disabledDateAfterToday,
                                              },
                                              "range-separator": "-",
                                              "start-placeholder": "開始日期",
                                              "end-placeholder": "結束日期",
                                            },
                                            model: {
                                              value: _vm.interviewDateRange,
                                              callback: function ($$v) {
                                                _vm.interviewDateRange = $$v
                                              },
                                              expression: "interviewDateRange",
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("需求單位"),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "請輸入關鍵字",
                                },
                                model: {
                                  value:
                                    _vm.searchCondition.applicantDepartment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchCondition,
                                      "applicantDepartment",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "searchCondition.applicantDepartment",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("單位面試主管"),
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-100",
                                  attrs: {
                                    "value-key": "Guid",
                                    filterable: "",
                                    placeholder: "請選擇",
                                  },
                                  model: {
                                    value:
                                      _vm.searchCondition.InterviewSupervisor,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchCondition,
                                        "InterviewSupervisor",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "searchCondition.InterviewSupervisor",
                                  },
                                },
                                _vm._l(
                                  _vm.supervisorOptions,
                                  function (supervisor) {
                                    return _c("el-option", {
                                      key: supervisor.Guid,
                                      attrs: {
                                        label: supervisor.Name,
                                        value: supervisor.Name,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("HR 面試人員"),
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-100",
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "請選擇",
                                  },
                                  model: {
                                    value: _vm.searchCondition.InterviewHR,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchCondition,
                                        "InterviewHR",
                                        $$v
                                      )
                                    },
                                    expression: "searchCondition.InterviewHR",
                                  },
                                },
                                _vm._l(
                                  _vm.supervisorOptions,
                                  function (supervisor) {
                                    return _c("el-option", {
                                      key: supervisor.Guid,
                                      attrs: {
                                        label: supervisor.Name,
                                        value: supervisor.Name,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("職缺編號"),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "請輸入關鍵字",
                                },
                                model: {
                                  value: _vm.searchCondition.manpowerDemandNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchCondition,
                                      "manpowerDemandNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "searchCondition.manpowerDemandNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("職缺名稱"),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "請輸入關鍵字",
                                },
                                model: {
                                  value: _vm.searchCondition.manpowerDemandName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchCondition,
                                      "manpowerDemandName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "searchCondition.manpowerDemandName",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "interviewee" } }, [
                                _vm._v("應聘者"),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "請輸入關鍵字",
                                },
                                model: {
                                  value: _vm.searchCondition.interviewee,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchCondition,
                                      "interviewee",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "searchCondition.interviewee",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              staticStyle: { "margin-top": "30px" },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  ;(_vm.currentPage = 1),
                                    handleSubmit(_vm.getInterviewed)
                                },
                              },
                            },
                            [_vm._v(" 查詢 ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              staticStyle: {
                                "margin-top": "30px",
                                "margin-left": "10px",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.searchCondition = {}
                                  _vm.interviewDateRange = [
                                    new Date(
                                      _vm
                                        .dayjs()
                                        .subtract(7, "day")
                                        .format("YYYY-MM-DD")
                                    ),
                                    new Date(_vm.$common.getToday()),
                                  ]
                                },
                              },
                            },
                            [_vm._v(" 清除 ")]
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm.personList.length > 0
        ? _c(
            "div",
            { staticClass: "tool-list" },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v("共計：" + _vm._s(_vm.totalPerson) + "人"),
              ]),
              _c("CardStyle", { on: { changeStyle: _vm.changeStyle } }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "person-card-list",
          class: {
            "list-style": _vm.gridStyle == "list",
            "block-style": _vm.gridStyle == "block",
          },
        },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            { key: index, staticClass: "person-card infinite-list-item" },
            [
              _c("PersonCard", {
                ref: "personCard",
                refInFor: true,
                attrs: { showCheckbox: false, person: person },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "tag",
                      fn: function ({ props }) {
                        return [
                          _c("div", { staticClass: "result" }, [
                            _vm._v(_vm._s(props.ApprovalResult)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "middleContent",
                      fn: function ({ props }) {
                        return [
                          _c("table", [
                            _c("tr", [
                              _c("th", [_vm._v("職缺名稱")]),
                              _c("td", [
                                _vm._v(_vm._s(props.ManpowerDemandName)),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("應徵職務")]),
                              _c("td", [_vm._v(_vm._s(props.Position))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("面談時間")]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$common.dateFormatter(
                                      props.InterviewDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("面談地點")]),
                              _c("td", [_vm._v(_vm._s(props.InterviewPlace))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("單位面試主管")]),
                              _c("td", [
                                _vm._v(_vm._s(props.InterviewSupervisor[0])),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("HR 面試人員")]),
                              _c("td", [_vm._v(_vm._s(props.InterviewHR[0]))]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "buttonGroup",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "el-dropdown",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "el-dropdown-link",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(" 檢視資訊"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showDetailModal(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視履歷 ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showProgressRecord(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視歷程 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickReinvite(props)
                                },
                              },
                            },
                            [_vm._v(" 重新邀約 ")]
                          ),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.getInterviewRecordHistory(
                                    props.MatchId
                                  )
                                },
                              },
                            },
                            [_vm._v(" 面談紀錄歷程 ")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.personList.length > 0
        ? _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.totalPerson,
              "page-size": 9,
            },
            on: { "current-change": _vm.changePage },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "declineInterviewReasonModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.personData.reason,
                        expression: "personData.reason",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      rows: "5",
                      placeholder: "請輸入原因",
                    },
                    domProps: { value: _vm.personData.reason },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.personData, "reason", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.saveDeclineInterviewReason },
                  },
                  [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c("ReinviteMailModal", {
        attrs: { personData: _vm.personData },
        on: { updatePerson: _vm.updatePerson },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "interviewRecordHistoryModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable",
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("ValidationObserver", {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ handleSubmit }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-start",
                                  staticStyle: { "margin-bottom": "10px" },
                                },
                                [
                                  _c("ValidationProvider", {
                                    ref: "addInterviewSupervisor",
                                    staticClass: "w-100",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("multiselect", {
                                                attrs: {
                                                  options:
                                                    _vm.supervisorOptions,
                                                  "close-on-select": false,
                                                  multiple: "",
                                                  tagPlaceholder: "",
                                                  selectLabel: "",
                                                  selectedLabel: "",
                                                  deselectLabel: "",
                                                  label: "Name",
                                                  "track-by": "Guid",
                                                  placeholder: "請選擇加簽人員",
                                                },
                                                model: {
                                                  value:
                                                    _vm.InterviewSupervisor,
                                                  callback: function ($$v) {
                                                    _vm.InterviewSupervisor =
                                                      $$v
                                                  },
                                                  expression:
                                                    "InterviewSupervisor",
                                                },
                                              }),
                                              _c(
                                                "p",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      staticStyle: {
                                        margin: "2px 0 0 10px",
                                        width: "70px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return handleSubmit(
                                            _vm.addInterviewRecord
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 加簽 ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c(
                      "div",
                      { staticClass: "evaluation-person-info" },
                      [
                        _c("div", [
                          _c("label", { attrs: { for: "" } }, [_vm._v("姓名")]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.recordList.Interviewee)),
                          ]),
                        ]),
                        _c(
                          "div",
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("面談日期"),
                            ]),
                            _vm._l(
                              _vm.recordList.InterviewDateList,
                              function (date, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$common.dateTimeFormatter(date)
                                      ) +
                                      " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._l(_vm.recordList.Scores, function (score) {
                          return _c("div", { key: score.Seq }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(score.Name)),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(score.OriginScore) +
                                  "/" +
                                  _vm._s(score.Score)
                              ),
                            ]),
                          ])
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              right: "5px",
                              bottom: "2px",
                              color: "#ffffff",
                              "z-index": "2",
                              "font-size": "0.9em",
                            },
                          },
                          [
                            _vm._v(
                              " 最後更新者：" +
                                _vm._s(_vm.recordList.UpdateUser) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                    _vm.recordList.InterviewRecords &&
                    _vm.recordList.InterviewRecords.length > 0
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "margin-top": "2px",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "evaluation-body fixed" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-name",
                                      staticStyle: {
                                        height: "60px",
                                        "line-height": "50px",
                                      },
                                    },
                                    [_vm._v(" 單位面試主管 ")]
                                  ),
                                  _vm._l(
                                    _vm.recordList.InterviewRecords[0]
                                      .InterviewRecordAppraisals,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "evaluation-field",
                                        },
                                        [_vm._v(" " + _vm._s(item.Name) + " ")]
                                      )
                                    }
                                  ),
                                  _vm.recordList.ResumeType === "IDL"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "evaluation-field" },
                                          [_vm._v("職等")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-field",
                                      staticStyle: {
                                        height: "150px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [_vm._v(" 面談說明 ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-field",
                                      staticStyle: {
                                        height: "150px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [_vm._v(" 個人備註 ")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "evaluation-field" },
                                    [_vm._v("面談結果")]
                                  ),
                                  _vm.recordList.ResumeType === "IDL"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "evaluation-field" },
                                          [_vm._v("是否已進行風險評估")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _c("div", {
                                    staticClass: "evaluation-field",
                                    staticStyle: { height: "42px" },
                                  }),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    "min-width": "1px",
                                  },
                                },
                                [
                                  _c(
                                    "carousel",
                                    {
                                      key: Math.random(),
                                      attrs: {
                                        items:
                                          _vm.recordList.InterviewRecords
                                            .length,
                                        nav: true,
                                        dots: false,
                                      },
                                    },
                                    _vm._l(
                                      _vm.recordList.InterviewRecords,
                                      function (record, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "evaluation-body",
                                            on: {
                                              dblclick: function ($event) {
                                                return _vm.$common.copyText(
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-name",
                                                staticStyle: { height: "60px" },
                                              },
                                              [
                                                _vm._v(
                                                  " 【" +
                                                    _vm._s(
                                                      record.InterviewTitle
                                                    ) +
                                                    "】"
                                                ),
                                                _c("br"),
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      effect: "dark",
                                                      content:
                                                        record.InterviewSupervisor +
                                                        " (" +
                                                        record.InterviewUserType +
                                                        ")",
                                                      placement: "right",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record.InterviewSupervisor
                                                          ) +
                                                          " (" +
                                                          _vm._s(
                                                            record.InterviewUserType
                                                          ) +
                                                          ") "
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._l(
                                              record.InterviewRecordAppraisals,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "evaluation-field",
                                                  },
                                                  [
                                                    item.Result !== "-" &&
                                                    item.Result !== "未填寫"
                                                      ? [
                                                          item.Remark
                                                            ? _c(
                                                                "el-tooltip",
                                                                {
                                                                  staticClass:
                                                                    "item",
                                                                  attrs: {
                                                                    effect:
                                                                      "dark",
                                                                    content:
                                                                      item.Remark,
                                                                    placement:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.Result
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.Result
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.Result)
                                                          ),
                                                        ]),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            _vm.recordList.ResumeType === "IDL"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "evaluation-field",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record.ExpectedJobLevel
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: {
                                                  height: "150px",
                                                  "overflow-y": "auto",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(record.Remark) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: {
                                                  height: "150px",
                                                  "overflow-y": "auto",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.PersonalRemark
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.InterviewResult
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm.recordList.ResumeType === "IDL"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "evaluation-field",
                                                  },
                                                  [
                                                    record.InterviewResult ===
                                                    "未填寫"
                                                      ? _c("div", [
                                                          _vm._v(" 未填寫 "),
                                                        ])
                                                      : _c("div", [
                                                          _vm._v(
                                                            " 已完成評估 "
                                                          ),
                                                        ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: { height: "42px" },
                                              },
                                              [
                                                record.InterviewResult ===
                                                "未填寫"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-warning btn-sm",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.interviewRecordUrge(
                                                              record.InterviewSupervisorId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" 催辦 ")]
                                                    )
                                                  : _c("div", [
                                                      _vm._v("已填寫面談紀錄"),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(" 關閉 ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.getApproveInterview(_vm.recordList)
                        },
                      },
                    },
                    [_vm._v(" 完成面談評估 ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("EvaluateInterviewModal", {
        attrs: {
          Source: "Interviewed",
          AdmitOptions: _vm.admitOptions,
          IdlRejectOptions: _vm.idlRejectOptions,
          DlRejectOptions: _vm.dlRejectOptions,
          Person: _vm.personData,
        },
        on: { saveApproveInterview: _vm.saveApproveInterview },
      }),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 0
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("履歷")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "item text-right" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$common.downloadResumePDF(
                                                      _vm.ResumeType,
                                                      _vm.ResumeId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 下載 PDF ")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("ProgressRecordModal", {
        attrs: { Name: _vm.Name, UserId: _vm.UserId, Email: _vm.Email },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("面談未到")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("面談紀錄歷程")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }